module.exports = __webpack_public_path__ + "img/jjfa_11.98600a7b.jpg";